export const LOGO_URL="https://tse4.mm.bing.net/th?id=OIF.91E5eILwJWQ5cMwZWRWotQ&pid=Api&P=0&h=180";

export const MENU_API =
  "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9351929&lng=77.62448069999999&restaurantId=";

  export const IMG_cdn_URL= "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";